import { render } from "./Dashboard-EIS-Pejabat-Tanah.vue?vue&type=template&id=66450f5b"
import script from "./Dashboard-EIS-Pejabat-Tanah.vue?vue&type=script&lang=js"
export * from "./Dashboard-EIS-Pejabat-Tanah.vue?vue&type=script&lang=js"

import "./Dashboard-EIS-Pejabat-Tanah.vue?vue&type=style&index=0&id=66450f5b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__